import(/* webpackMode: "eager", webpackExports: ["MethodsCatalogClient"] */ "/app/dashboard/app/_components/MethodsCatalogClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
